import { LINKS, PATHS } from '~/constants';
import { type Menu, MODIFIERS, KEY } from './types';

const MENU: Menu = [
  {
    key: KEY.PRODUCT,
    i18nKey: PATHS.PRODUCT.i18nKey,
    columns: [
      [{ i18nKey: 'Overview', path: PATHS.PRODUCT.path }],
      [PATHS.CONSUMPTION_MODEL],
    ],
  },
  {
    key: KEY.RESOURCES,
    i18nKey: PATHS.RESOURCES.i18nKey,
    columns: [
      [
        { i18nKey: 'Tools' },
        {
          i18nKey: 'Storage_Calculator',
          path: PATHS.BACKUP_STORAGE_CALCULATOR.path,
          modifier: MODIFIERS.NEW,
        },
      ],
      [
        { i18nKey: 'Resource_Library' },
        PATHS.WHITE_PAPERS,
        PATHS.TECHNICAL_PAPERS,
        PATHS.CASE_STUDIES,
      ],
      [{ i18nKey: 'Insights' }, PATHS.GUIDES, PATHS.ANALYST_REPORTS],
    ],
  },
  {
    key: KEY.PARTNERS,
    i18nKey: PATHS.PARTNERS.i18nKey,
    columns: [
      [{ i18nKey: 'Become_A_Partner', path: PATHS.PARTNERS.path }],
      [{ i18nKey: 'Access_Portal', path: LINKS.PARTNERS }],
      // [{ i18nKey: 'Find_Distributor', path: '#' }],
    ],
  },
  {
    key: KEY.COMPANY,
    i18nKey: 'Company',
    columns: [
      [PATHS.ABOUT, PATHS.CAREERS, PATHS.CONTACTS_US],
      [PATHS.BLOG, PATHS.ACES_PROGRAM],
      [PATHS.EVENTS, { path: PATHS.NEWSROOM.path, i18nKey: 'News' }],
    ],
  },
  {
    key: KEY.SUPPORT,
    i18nKey: 'Support',
    columns: [
      [{ i18nKey: 'Contact_Support', path: PATHS.SUPPORT.path }],
      [PATHS.INSTALLATION],
      [PATHS.HELP],
    ],
  },
];

export default MENU;
